/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoalRequest } from './GoalRequest';
import {
    GoalRequestFromJSON,
    GoalRequestFromJSONTyped,
    GoalRequestToJSON,
    GoalRequestToJSONTyped,
} from './GoalRequest';

/**
 * 
 * @export
 * @interface UpdateClientGoalsRequest
 */
export interface UpdateClientGoalsRequest {
    /**
     * 
     * @type {Array<GoalRequest>}
     * @memberof UpdateClientGoalsRequest
     */
    goals: Array<GoalRequest>;
}

/**
 * Check if a given object implements the UpdateClientGoalsRequest interface.
 */
export function instanceOfUpdateClientGoalsRequest(value: object): value is UpdateClientGoalsRequest {
    if (!('goals' in value) || value['goals'] === undefined) return false;
    return true;
}

export function UpdateClientGoalsRequestFromJSON(json: any): UpdateClientGoalsRequest {
    return UpdateClientGoalsRequestFromJSONTyped(json, false);
}

export function UpdateClientGoalsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClientGoalsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'goals': ((json['goals'] as Array<any>).map(GoalRequestFromJSON)),
    };
}

export function UpdateClientGoalsRequestToJSON(json: any): UpdateClientGoalsRequest {
    return UpdateClientGoalsRequestToJSONTyped(json, false);
}

export function UpdateClientGoalsRequestToJSONTyped(value?: UpdateClientGoalsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goals': ((value['goals'] as Array<any>).map(GoalRequestToJSON)),
    };
}

